<template>
    <router-view />
</template>

<script>
export default {
    name: "account",
};
</script>

<style lang="scss">
#account {
    min-height: 100vh;

    width: 100%;
    background: $darkGrey_1;
    color: white;
    z-index: 50;
    position: relative;
    header {
        background: $darkGrey_0;
        padding: 25px;
        position: fixed;
        width: 100%;
        top: 0px;
        z-index: 1;
        font-size: 22px;
        height: 100px;
        padding-top: 40px;
        margin-top: env(safe-area-inset-top) !important;
        .icon {
            float: right;
            color: white;
        }
    }
    .form {
        padding: 20px;
        padding-top: 118px;

        &:before {
            content: "";
            width: 100%;
            height: 12px;
            background: #555855;
            position: fixed;
            left: 0px;
            top: 88px;
            border-top-right-radius: 12px;
            border-top-left-radius: 12px;
            z-index: 1;
            margin-top: env(safe-area-inset-top) !important;
        }

        .formGroup {
            margin-bottom: 20px;
            position: relative;
            label {
                display: block;
                color: #939a93;

                &.highlight {
                    color: white;
                    font-size: 20px;
                }
            }
            &.b {
                padding-top: 20px;
                border-top: 1px solid #444745;
                padding-bottom: 20px;
                margin-bottom: 0px;
            }
            input[type="text"],
            input[type="date"],
            input[type="url"],
            input[type="email"],
            input[type="password"],
            input[type="tel"],
            select,
            textarea {
                width: 100%;
                max-width: 100%;
                font-size: 20px;
                background: transparent;
                border: 0px;
                padding: 10px 10px 10px 0px;
                color: white;
                border-bottom: 1px solid $darkGrey_0;
                font-family: canada-type-gibson, sans-serif;
                select {
                    appearance: none;
                }
                &:focus {
                    outline: 0;
                }
            }
            input[type="date"]::-webkit-calendar-picker-indicator {
                -webkit-appearance: none;
            }
            .invalid-feedback {
                color: red;
                margin-top: 8px;
            }
        }
        .help {
            line-height: 1.5;
        }
    }
    ul {
        padding: 0px 25px;
        padding-top: 112px;
        position: relative;
        &:before {
            content: "";
            width: 100%;
            height: 12px;
            background: #555855;
            position: fixed;
            left: 0px;
            top: 88px;
            border-top-right-radius: 12px;
            border-top-left-radius: 12px;
            z-index: 1;
            margin-top: env(safe-area-inset-top) !important;
        }
        li {
            border-bottom: 1px solid $darkGrey_0;
            &.nb {
                border: 0px;
            }
            a {
                color: white;
                display: block;
                text-decoration: none;
                padding: 20px 0px;
                font-size: 20px;
                position: relative;
                .icon {
                    position: absolute;
                    right: 0px;
                    top: 18px;
                }
                &.button {
                    margin-top: 20px;
                    padding: 20px;
                    text-align: center;
                }
            }
        }
    }
}
</style>
